<div class="templates-wrapper">
  <!-- Templates List filter bar -->
  @if (!isTypeList) {
<div class="gt-filter-container">
    <div class="gt-filter-item">
      <i class="fa fa-refresh gt-refresh"
         [class.spinning]="loading"
         title="Refresh Data"
         role="button"
         tabindex="0"
         (click)="refresh()"
         (keydown.enter)="refresh()"
         (keydown.space)="refresh(); $event.preventDefault()"></i>
    </div>
    <div class="gt-filter-item">
      <div class="btn btn-success btn-xs" (click)="addTemplate()">Add New Template</div>
    </div>
    <div class="gt-filter-item">
      <a class="gt-nav-link" (click)="navigateToTypeList()">Manage Template Types</a>
    </div>
  </div>
}

  <!-- Templates Type List filter bar -->
  @if (isTypeList) {
<div class="gt-filter-container">
    <div class="gt-filter-item">
      <i class="fa fa-refresh gt-refresh"
         [class.spinning]="loading"
         title="Refresh Data"
         role="button"
         tabindex="0"
         (click)="refresh()"
         (keydown.enter)="refresh()"
         (keydown.space)="refresh(); $event.preventDefault()"></i>
    </div>
    <div class="gt-filter-item">
      <div class="btn btn-success btn-xs" (click)="addTemplateType()">Add New Template Type</div>
    </div>
    <div class="gt-filter-item">
      <a class="gt-nav-link" (click)="navigateToTemplatesList()">Manage Templates</a>
    </div>
  </div>
}

  <div adminGrid
       [gridConfig]="gridConfig"
       (gridCallback)="onGridCallback($event)"
       (gridDataLoaded)="onGridDataLoaded($event)"
       (loadingStateChange)="loading = $event"
       class="gizmo-grid"
       tabindex="2"></div>
</div>
